<script lang="ts">
    import { spaNavigate } from "../lib/actions"
    import Account from "../lib/components/pagebuilder/profile/Account.svelte"
    import Login from "../lib/components/pagebuilder/profile/Login.svelte"
    import PasswordReset from "../lib/components/pagebuilder/profile/PasswordReset.svelte"
    import PasswordResetRequest from "../lib/components/pagebuilder/profile/PasswordResetRequest.svelte"
    import Register from "../lib/components/pagebuilder/profile/Register.svelte"
    import PageTitle from "../lib/components/widgets/PageTitle.svelte"
    import { location, login } from "../lib/store"
    import Orders from "../lib/components/pagebuilder/profile/Orders.svelte"
    import Profile from "../lib/components/pagebuilder/profile/Profile.svelte"

    $: isLoggedIn = Boolean($login?.tokenData)
    $: config = !isLoggedIn
        ? [
              {
                  title: "Login",
                  path: "login",
                  component: Login,
              },
              {
                  title: "Registrieren",
                  path: "register",
                  component: Register,
              },
              {
                  title: "Passwort Vergessen",
                  path: "forgot-password",
                  component: PasswordResetRequest,
              },
              {
                  title: "Passwort Zurücksetzen",
                  path: "reset-password",
                  requirement: (location: LocationStore) => {
                      if (!location) return false
                      return location.search.includes("token")
                  },
                  component: PasswordReset,
              },
          ]
        : [
              {
                  title: "Account",
                  path: "account",
                  component: Account,
              },
              {
                  title: "Bestellungen",
                  path: "orders",
                  component: Orders,
              },
              {
                  title: "Profil",
                  path: "",
                  component: Profile,
              },
          ]
    let activeTab = 0
    $: if ($location?.path?.startsWith("/profile")) {
        const fPath = $location.path
        if ((fPath === "/profile" || fPath === "/profile/") && isLoggedIn) activeTab = 2
        else {
            const path = $location.path.split("/profile/")[1]
            const index = config.findIndex((c) => c.path.includes(path))
            if (index !== -1) activeTab = index
        }
    }
</script>

<PageTitle title="Profil" />
{#key $location}
    <div class="sticky-bar">
        <ul class="bar">
            {#each config as item, i}
                {#if !item.requirement || item.requirement($location)}
                    <li>
                        <button
                            class:active="{activeTab === i}"
                            on:click="{() => {
                                spaNavigate(`/profile/${item.path}`)
                                activeTab = i
                            }}"
                        >
                            <p>{item.title}</p>
                            <img
                                class="right-side-crinkle"
                                class:visible="{activeTab === i}"
                                src="/media/bottomLeftCrinkleWhiteXS.svg"
                                alt="crinkle"
                            />
                        </button>
                    </li>
                {/if}
            {/each}
        </ul>
    </div>
{/key}

<svelte:component this="{config[activeTab].component}" />

<style lang="less">
    .sticky-bar {
        top: 86px;
        width: 100%;
        position: sticky;
        z-index: 1000;
        display: flex;
        justify-content: center;

        background-color: #0d0c0c;
        .bar {
            max-width: var(--normal-max-width);
            width: 100%;
            height: 48px;

            display: flex;
            justify-content: flex-start;
            width: 100%;
            height: 100%;
            gap: 10px;

            button {
                background: transparent;
                display: flex;
                color: var(--text-300);
                height: 100%;
                p {
                    height: 100%;
                    flex-grow: 1;
                    display: flex;
                    align-items: center;
                    font-weight: 700;
                    padding: 11px 24px;
                    line-height: 0.7rem;
                }
                img {
                    width: 0px;
                    height: 100%;
                    overflow: hidden;
                }
                &.active {
                    p {
                        color: var(--bg-200);
                        background-color: white;
                    }
                    img {
                        width: 48px;
                    }
                }
            }
        }
    }
</style>
